<template>
    <div>
        <ListPage ref="listPage" :query="query" :total="total" v-loading="loading" :data="tableData"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch"
            @reset="resetQuery" @selection-change="handleSelectionChange">
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="输入姓名进行检索" clearable
                        @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="等级" prop="search_user_level">
                    <LevelSelector v-model="query.search_user_level"></LevelSelector>
                </el-form-item>
            </template>
            <template slot="btns"
                v-if="permission('dlgl_dlylb_djpz') || permission('dlgl_dlylb_pldc') || permission('dlgl_dlylb_szdly') || permission('dlgl_dlylb_xz')">
                <el-button v-if="permission('dlgl_dlylb_djpz')" size="mini" type="primary" @click="handleLevel"> 等级配置
                </el-button>
                <el-button v-if="permission('dlgl_dlylb_pldc')" size="mini" type="primary" @click="handleExport"> 批量导出
                </el-button>
                <el-button v-if="permission('dlgl_dlylb_szdly')" size="mini" type="primary" @click="handleProxy"> 设置代理员
                </el-button>
                <el-button v-if="permission('dlgl_dlylb_xz')" size="mini" type="primary" @click="handleAdd"> 新增
                </el-button>
            </template>
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="ID" align="center" prop="uuid" show-overflow-tooltip />
                <el-table-column label="姓名" align="center" prop="nick_name" />
                <el-table-column label="手机" align="center" prop="mobile">
                    <template slot-scope="{ row }">
                        <span>{{ row.mobile || "/" }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="邮箱" align="center" prop="email">
                    <template slot-scope="{ row }">
                        <span>{{ row.email || "/" }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="等级" align="center" prop="level.name" />
                <el-table-column label="推广总数" align="center" prop="inviter_count" />
                <el-table-column
                    v-if="permission('dlgl_dlylb_ck') || permission('dlgl_dlylb_bj') || permission('dlgl_dlylb_sc')"
                    label="操作" align="center" width="140">
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('dlgl_dlylb_ck')" size="mini" type="text"
                            @click="handleDetail(row)"> 查看 </el-button>
                        <el-button v-if="permission('dlgl_dlylb_bj')" size="mini" type="text" @click="handleEdit(row)">
                            编辑 </el-button>
                        <el-button v-if="permission('dlgl_dlylb_sc')" size="mini" type="text" @click="handleDel(row)">
                            删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <UserPicker ref="userPicker" @update="search"></UserPicker>
    </div>
</template>

<script>
import { list, del } from "@/api/member/list";
import listMixin from "@/mixins/list";
import UserPicker from "./userPicker.vue";
import LevelSelector from "@/components/LevelSelector";
import { downloadFileByUrl } from "@/jslibs/utils";

export default {
    components: { UserPicker, LevelSelector },
    data() {
        return {
            del,
            list,
            // 查询参数
            query: {
                search_user_role: "2",
                search_keyword: "",
            },
            module: "用户",
            formPath: "/proxy/list/form",
            detailPath: "/proxy/list/detail",
            pick: true,
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleLevel() {
            this.$router.push({ path: "/proxy/level" });
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        async handleExport() {
            const filename = "代理员列表.xlsx";
            const { search_keyword } = this.query;
            const uuids = this.picks.map(x => x.uuid).join();
            downloadFileByUrl(process.env.VUE_APP_BASE_URL + `/v1/cms/user?export=1&search_user_role=2&search_keyword=${search_keyword}&uuids=${uuids}`, filename);
        },
        handleProxy() {
            this.$refs.userPicker.open();
        },
    },
};
</script>
